module.exports = __webpack_public_path__ + "img/3F3D52_CCCED9_AFB0C6_8D8CAC-256px.3e72784d.png";